import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  getHolidayList,
  getReimbursementBills,
  getReimbursementCategories,
  getReimbursementCategoryData,
} from "_controllers/officer";
import authAxios from "setups/axios";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { DeleteConfirmationModel } from "utils/helperComponent";
import { toastMessage } from "utils/toastMessage";
import Chart from "react-apexcharts";
import ViewBills from "./ViewBills";
import ExpenseBreakup from "./ExpenseBreakup";

const messageStyle = {
  width: "50%",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const Main = () => {
  const [data, setData] = useState([]);
  const [billsData, setBillsData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [viewBillData, setViewBillData] = useState();

  const [isBreakupOpen, setIsBreakupOpen] = useState(false);

  const [addEdit, setAddEdit] = useState("Add");
  const [editId, seteditId] = useState("");

  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState([]);

  const [schemeErr, setschemeErr] = useState({
    category: false,
    subCategory: false,
  });

  const Validate = () => {
    let value = true;
    let err = {};

    if (category === "" || category === " ") {
      err.category = "Please Enter Category Name.";
      value = false;
    }

    if (subCategory.length === 0) {
      err.subCategory = "Please Enter Sub Category";
      value = false;
    }
    setschemeErr({ ...err });
    return value;
  };

  useEffect(async () => {
    const categoryData = await getReimbursementCategories();
    setData(categoryData?.data);
    setMessage(categoryData?.message);
    setLoading(true);
    setTotalPages(categoryData?.totalPage ?? 1);
  }, []);

  useEffect(async () => {
    const bills = await getReimbursementBills();
    setBillsData(bills?.data);
    setMessage(bills?.message);
    setLoading(true);
  }, []);

  useEffect(async () => {
    const category = await getReimbursementCategoryData();
    setCategoryData(category?.data);
    setMessage(category?.message);
    setLoading(true);
  }, []);

  const handleKeyPress = (e) => {
    const allowedCharacters = /^[a-zA-Z\s]+$/;
    if (!allowedCharacters.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleSelectedItemsChange = (event, newValue) => {
    setSubCategory(newValue);
  };

  const handleAddItem = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      setSubCategory((prevItems) => [...prevItems, event.target.value]);
      event.target.value = "";
    }
  };

  const handleOpenModal = (data) => {
    setViewBillData(data);
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setViewBillData();
    setIsOpen(false);
  };

  const handleOpenBreakupModal = (data) => {
    setViewBillData(data);
    setIsBreakupOpen(true);
  };

  const handleBreakupClose = () => {
    setViewBillData();
    setIsBreakupOpen(false);
  };

  let topCategories = ["1", "2", "3", "4"];

  console.log("cate", categoryData);

  return (
    <>
      <div>
        <p
          style={{
            font: "25px",
            fontWeight: "bolder",
            color: "darkgrey",
          }}
        >
          Expense Overview
        </p>
      </div>
      <div
        style={{
          width: "98%",
          border: "1.5px solid grey",
          marginBottom: "1rem",
        }}
      />
      <div
        style={{
          display: "flex",
          //   justifyContent: "flex-end",
          margin: "1rem 0 1rem 0",
        }}
      >
        <p
          style={{
            fontFamily: "Poppins",
            fontWeight: "500",
            fontSize: "22px",
            color: "#383838",
          }}
        >
          Reimbursement
        </p>
      </div>

      <div
        style={{
          backgroundColor: "#F4F4F4",
          padding: "1rem",
          marginRight: "1rem",
        }}
      >
        <div
          style={{
            height: "350px",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            // padding: "1rem",
          }}
        >
          <div
            style={{
              width: "33%",
              backgroundColor: "#FCFCFC",
              height: "98%",
              borderRadius: "20px",
            }}
          >
            <div
              style={{
                padding: "1rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "#565A6D",
                  }}
                >
                  All Bils
                </p>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "30px",
                    fontWeight: "600",
                    color: "#0E132F",
                    marginTop: "5px",
                  }}
                >
                  {billsData
                    ?.reduce((acc, crr) => acc + crr?.totalAmount, 0)
                    .toLocaleString()}
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#3273F6",
                    borderBottom: "1px solid #3273F6",
                  }}
                  onClick={() => handleOpenBreakupModal(billsData)}
                >
                  See Breakup
                </p>
              </div>
            </div>
            <div
              style={{
                padding: "10px",
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#FCFCFC",
                  border: "1px solid rgba(225, 225, 225, 0.25)",
                  padding: "10px 15px",
                  borderRadius: "20px",
                }}
              >
                <div>
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#565A6D",
                    }}
                  >
                    Pending Bills
                  </p>
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#0E132F",
                      marginTop: "5px",
                    }}
                  >
                    ₹{" "}
                    {billsData
                      .find((item) => item._id === "Pending")
                      ?.totalAmount.toLocaleString() || 0}
                  </p>
                </div>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "#96795B",
                  }}
                  onClick={() =>
                    handleOpenModal(
                      billsData.find((item) => item._id === "Pending")
                    )
                  }
                >
                  View Bills
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#FCFCFC",
                  border: "1px solid rgba(225, 225, 225, 0.25)",
                  padding: "10px 15px",
                  borderRadius: "20px",
                }}
              >
                <div>
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#565A6D",
                    }}
                  >
                    Approved Bills
                  </p>
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#0E132F",
                      marginTop: "5px",
                    }}
                  >
                    ₹{" "}
                    {billsData
                      .find((item) => item._id === "Approved")
                      ?.totalAmount.toLocaleString() || 0}
                  </p>
                </div>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "#96795B",
                  }}
                  onClick={() =>
                    handleOpenModal(
                      billsData.find((item) => item._id === "Approved")
                    )
                  }
                >
                  View Bills
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#FCFCFC",
                  border: "1px solid rgba(225, 225, 225, 0.25)",
                  padding: "10px 15px",
                  borderRadius: "20px",
                }}
              >
                <div>
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#565A6D",
                    }}
                  >
                    Rejected Bills
                  </p>
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#0E132F",
                      marginTop: "5px",
                    }}
                  >
                    ₹{" "}
                    {billsData
                      .find((item) => item._id === "Rejected")
                      ?.totalAmount.toLocaleString() || 0}
                  </p>
                </div>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "#96795B",
                  }}
                  onClick={() =>
                    handleOpenModal(
                      billsData.find((item) => item._id === "Rejected")
                    )
                  }
                >
                  View Bills
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              width: "30%",
              backgroundColor: "#FCFCFC",
              height: "98%",
              borderRadius: "20px",
            }}
          >
            <p
              style={{
                fontSize: "20px",
                fontWeight: "500",
                fontFamily: "Poppins",
                color: "#383838",
                textAlign: "center",
                marginTop: "1rem",
              }}
            >
              Reimbursement Categories
            </p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                padding: "1rem",
                height: "90%",
              }}
            >
              {categoryData &&
                categoryData
                  .sort((a, b) => b.totalAmount - a.totalAmount)
                  .slice(0, 4)
                  .map((t) => (
                    <>
                      <div
                        style={{
                          backgroundColor: "#FCFCFC",
                          borderRadius: "16px",
                          boxShadow:
                            "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          margin: "0.5rem",
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            backgroundColor: "#0F0653",
                            color: "#ffffff",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {t?._id.slice(0, 1)}
                        </div>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#565A6D",
                            padding: "10px 0",
                          }}
                        >
                          {t?._id}
                        </p>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#0E132F",
                            marginTop: "5px",
                          }}
                        >
                          ₹ {t?.totalAmount.toLocaleString()}
                        </p>
                      </div>
                    </>
                  ))}
            </div>
          </div>
          <div
            style={{
              width: "33%",
              backgroundColor: "#FCFCFC",
              height: "98%",
              borderRadius: "20px",
            }}
          >
            <Chart
              type="donut"
              width={"100%"}
              height={"100%"}
              series={[100, 75, 150, 80, 120]}
              options={{
                labels: ["North", "East", "South-West", "South", "West"],
                // title: {
                //   text: "Visit By Start & End Location.",
                //   align: "center",
                // },
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "bottom",
                },
              }}
            />
          </div>
        </div>
        <div
          style={{
            height: "250px",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <div
            style={{
              width: "48%",
              backgroundColor: "#FCFCFC",
              height: "98%",
              borderRadius: "20px",
            }}
          >
            <Chart
              type="bar"
              width={"100%"}
              height={"100%"}
              series={[
                {
                  name: "Last Month",
                  data: [100, 220, 150, 175, 300],
                  color: "#3273F6",
                },
                {
                  name: "Current Month",
                  data: [0, 100, 150, 250, 125],
                  color: "rgba(56, 84, 200, 1)",
                },
              ]}
              options={{
                labels: ["Phone", "Food", "Travel", "Gas", "Parking"],
                title: {
                  text: "This Month vs Last Month",
                  align: "left",
                  style: {
                    marginTop: "20px",
                    marginLeft: "2rem",
                  },
                },
                chart: {
                  toolbar: {
                    show: false, //Disable toolbar
                  },
                },
                stroke: {
                  show: true,
                  width: 3,
                  colors: ["transparent"],
                },
                tooltip: { followCursor: true },
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "top",
                },
              }}
            />
          </div>
          <div
            style={{
              width: "48%",
              backgroundColor: "#FCFCFC",
              height: "98%",
              borderRadius: "20px",
            }}
          >
            <Chart
              type="bar"
              width={"100%"}
              height={"100%"}
              series={[
                {
                  name: "Last Month",
                  data: categoryData
                    ?.sort((a, b) => a?._id.localeCompare(b?._id))
                    ?.map((a) => a?.totalAmount),
                  color: "#EFA348",
                },
              ]}
              options={{
                labels: categoryData
                  ?.sort((a, b) => a?._id.localeCompare(b?._id))
                  ?.map((a) => a?._id),
                title: {
                  text: "Spend By Categories",
                  align: "left",
                  style: {
                    marginTop: "20px",
                    marginLeft: "2rem",
                  },
                },
                chart: {
                  toolbar: {
                    show: false,
                  },
                },
                stroke: {
                  show: true,
                  width: 3,
                  colors: ["transparent"],
                },
                tooltip: { followCursor: true },
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "top",
                },
              }}
            />
          </div>
        </div>
      </div>
      <ViewBills
        isOpen={isOpen}
        handleClose={handleCloseModal}
        data={viewBillData}
      />
      {isBreakupOpen ? (
        <ExpenseBreakup
          isBreakupOpen={isBreakupOpen}
          handleBreakupClose={handleBreakupClose}
          data={viewBillData}
        />
      ) : null}
    </>
  );
};

const ExpenseDashboard = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default ExpenseDashboard;
